<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Contents</p>
<p class="toc"><a href="#/preface">Preface</a></p>
<p class="toc1"><a href="#/chapter01">Case 1: St. Valentine’s Day Murders</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Case 2: Hate + Revenge = Murder</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Case 3: Predator</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Case 4: Murder in Pittsford</span></p>
<p class="toc1"><span href="#/finalcomments" title="Link target outside of Sample">Final Comments</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1676a44e